import { store } from "~/state/store";
import { setCopyrights as setCopyrightsStore } from "~/state/map/state";

export interface ICopyright {
	[key: string]: Array<string>;
}

export function setCopyrights(zoom: number, copyrightObjs: Array<ICopyright>) {
	let copyrights: Array<string> = [];

	copyrightObjs.forEach(copyrightObj => {
		Object.keys(copyrightObj).forEach(copyrightKey => {
			const parts = copyrightKey.split("-");

			if (!parts.length) {
				return;
			}

			const copyrigthsArray = copyrightObj[copyrightKey];
			// -
			let addCopyrights = parts[0] === "" && parts[1] === "";

			// 1-
			if (!addCopyrights && parts[0] !== "" && parts[1] === "") {
				const fromZoom = parseFloat(parts[0]);

				addCopyrights = zoom >= fromZoom;
			// 1-2
			} else if (!addCopyrights) {
				const fromZoom = parseFloat(parts[0]);
				const toZoom = parseFloat(parts[1]);

				addCopyrights = zoom >= fromZoom && zoom <= toZoom;
			}

			if (addCopyrights) {
				copyrights = copyrights.concat(copyrigthsArray);
			}
		});
	});

	store.dispatch(setCopyrightsStore(copyrights));
}
